<template>
  <div class="bg-white height-100 w-full flex justify-center items-center">
    <div class="">
      <div class="rounded-full flex justify-center">
        <img
          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-product/file-type.png"
          alt=""
        />
      </div>

      <div class="mt-4">
        <h1 class="font-bold text-center">File type should be jpg/png/pdf</h1>
      </div>
      <div class="w-full flex justify-center gap-3 mt-4">
        <button
          class="w-1/2 bg-primary text-white fsize14 px-8 py-4 border-0 rounded-lg"
        >
          Okay
        </button>
        <button
          class="w-1/2 bg-gray text-white fsize14 px-8 py-4 border-0 rounded-lg"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
